import { useUserUUID } from '@annunciate/core';
import { TAGS_GET } from '@annunciate/query/dist/queries/tag';
import { useQuery } from './base';
export const useTagsQuery = () => {
    const uuid = useUserUUID(true);
    return useQuery(['tag', uuid], TAGS_GET, undefined, {
        gcTime: 10 * 60 * 1000,
        staleTime: 10 * 60 * 1000,
    }, (data) => data.tags);
};
//# sourceMappingURL=useTagsQuery.js.map